"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentLetter = ParentLetter;
exports.GrandparentLetter = GrandparentLetter;
const unicode_arabic_1 = require("./unicode-arabic");
const isArabic_1 = require("./isArabic");
const reference_1 = require("./reference");
function ParentLetter(letter) {
    if (!(0, isArabic_1.isArabic)(letter)) {
        throw new Error('Not an Arabic letter');
    }
    for (let w = 0; w < reference_1.letterList.length; w++) {
        // ok so we are checking this potential lettertron
        let letterForms = unicode_arabic_1.default[reference_1.letterList[w]];
        let versions = Object.keys(letterForms);
        for (let v = 0; v < versions.length; v++) {
            let localVersion = letterForms[versions[v]];
            if (typeof localVersion === 'object' && typeof localVersion.indexOf === 'undefined') {
                // look at this embedded object
                let embeddedForms = Object.keys(localVersion);
                for (let ef = 0; ef < embeddedForms.length; ef++) {
                    let form = localVersion[embeddedForms[ef]];
                    if (form === letter || (typeof form === 'object' && form.indexOf && form.indexOf(letter) > -1)) {
                        // match
                        return localVersion;
                    }
                }
            }
            else if (localVersion === letter || (typeof localVersion === 'object' && localVersion.indexOf && localVersion.indexOf(letter) > -1)) {
                // match
                return letterForms;
            }
        }
        return null;
    }
}
function GrandparentLetter(letter) {
    if (!(0, isArabic_1.isArabic)(letter)) {
        throw new Error('Not an Arabic letter');
    }
    for (let w = 0; w < reference_1.letterList.length; w++) {
        // ok so we are checking this potential lettertron
        let letterForms = unicode_arabic_1.default[reference_1.letterList[w]];
        let versions = Object.keys(letterForms);
        for (let v = 0; v < versions.length; v++) {
            let localVersion = letterForms[versions[v]];
            if (typeof localVersion === 'object' && typeof localVersion.indexOf === 'undefined') {
                // look at this embedded object
                let embeddedForms = Object.keys(localVersion);
                for (let ef = 0; ef < embeddedForms.length; ef++) {
                    let form = localVersion[embeddedForms[ef]];
                    if (form === letter || (typeof form === 'object' && form.indexOf && form.indexOf(letter) > -1)) {
                        // match
                        return letterForms;
                    }
                }
            }
            else if (localVersion === letter || (typeof localVersion === 'object' && localVersion.indexOf && localVersion.indexOf(letter) > -1)) {
                // match
                return letterForms;
            }
        }
        return null;
    }
}
